import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/20/solid'
import type { ProgressStep } from '../../lib/adPromotion'

const LABEL: Record<ProgressStep['status'], string> = {
  done: 'font-medium text-green-700',
  in_progress: 'font-medium text-indigo-700',
  error: 'font-medium text-red-700',
  pending: 'text-gray-400',
}

export default function PromoteProgress({ steps, error }: { steps: ProgressStep[]; error?: string }) {
  return (
    <div className="space-y-4">
      {steps.map(({ key, label, status }) => (
        <div key={key} className="flex items-center gap-3">
          <div className="shrink-0">
            {status === 'done' ? (
              <CheckCircleIcon className="size-6 text-green-500" />
            ) : status === 'in_progress' ? (
              <span className="block size-6 animate-spin rounded-full border-2 border-indigo-200 border-t-indigo-500" />
            ) : status === 'error' ? (
              <XCircleIcon className="size-6 text-red-500" />
            ) : (
              <div className="ml-0.5 size-5 rounded-full border-2 border-gray-300" />
            )}
          </div>
          <span className={`text-sm ${LABEL[status]}`}>{label}</span>
        </div>
      ))}

      {error && <p className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-600">{error}</p>}
    </div>
  )
}
